import React from "react";
import CustomSelect from "../common/Select";

const opcionesClasificacion = [
  { value: "0", label: "INACTIVO" },
  { value: "1", label: "ACTIVO" },
  { value: "2", label: "TERMINADO" },
  { value: "3", label: "FALLECIDO" },
  { value: "4", label: "PENDIENTE POR INICIAR" }
];

function SelectorClasificacionPaciente({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesClasificacion}
      value={value}
      onChange={onChange}
      placeholder="Seleccione..."
      label="Clasificación"
      error={error}
      required={required}
    />
  );
}

export default SelectorClasificacionPaciente;